import { Lookup, useLookup } from '@/providers'
import { Autocomplete, TextField } from '@mui/material'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function MatchType({ value, updateFilters }: Props) {
	const options = useLookup(Lookup.MatchTypeFilters)

	const selectedValues = options.find((v) => v.id === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ matchType: value.id })
		} else {
			updateFilters({ matchType: null })
		}
	}

	return (
		<Autocomplete
			fullWidth
			size="small"
			options={options}
			value={selectedValues}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Match Type" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
